import { MatchedRoute, matchRoutes } from 'react-router-config';
import routes, { ICustomRouteConfig } from 'routes';

interface IUseRouteProps {
  pathname: string
}
interface IUseRoute<IMatchParams extends { [K in keyof IMatchParams]?: string } = undefined> {
  matchedRoute: MatchedRoute<IMatchParams, ICustomRouteConfig>
}

function useRoute<IMatchParams extends { [K in keyof IMatchParams]?: string } = undefined>(props: IUseRouteProps): IUseRoute<IMatchParams> {
  const { pathname } = props;

  const matchedRoutes = matchRoutes<any, ICustomRouteConfig>(routes, pathname);
  const matchedRoute = matchedRoutes?.[matchedRoutes.length - 1];

  return { matchedRoute };
}

export default useRoute;
